import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PromotionItem from "./PromotionItem";
import { IState } from "store/store.interface";
import { isEmpty } from "utils/app.utils";
import LoaderCampaings from "Loader/Dashboard";
import { useApiInfo } from "hooks";
import { PROMOTION_FETCH_CAMPAIGNS, AUTH_VERIFY_BOUND_STORE } from "store/store.types";
import { fetchCampaigns } from "store/actions/promotion.actions";
import { Box } from "common";
import EmptyState from "./EmptyState";
import { useStyles } from "./Dashboard.style";

const PromotionListing: FC<{ listing?: "list" | "grid" }> = ({ listing }) => {
  const [activeAccordionId, setActiveAccordionId] = useState<string | null>(null);
  const { dashboard, newCampaign, campaignMode } = useSelector(
    (state: IState) => state.promotion
  );
  const { storeIds = [] } = useSelector((state: IState) => state.auth);
  const { container, emptyContainer } = useStyles({ listing });

  const dispatch = useDispatch();
  const { isLoading, done: fetchDone } = useApiInfo(PROMOTION_FETCH_CAMPAIGNS);
  const { success: switchStoreSuccess } = useApiInfo(AUTH_VERIFY_BOUND_STORE);
  const needsServerStoreBind = storeIds.length > 1;

  useEffect(() => {
    if (newCampaign) {
      dispatch(fetchCampaigns());
    }
  }, [newCampaign, dispatch]);

  useEffect(() => {
    if (!campaignMode) return;
    if (needsServerStoreBind && !switchStoreSuccess) return;
    if (isLoading || fetchDone) return;
    dispatch(fetchCampaigns());
  }, [dispatch, campaignMode, needsServerStoreBind, switchStoreSuccess, isLoading, fetchDone]);

  if (isEmpty(dashboard) && isLoading) {
    return <LoaderCampaings />;
  }
  return (
    <Box className={(dashboard && dashboard.length > 0) ? container : emptyContainer} width="100%" gridGap="25px">
      {dashboard && dashboard.length > 0 ? (
        <>
          {dashboard.map((promotion) => {
            if (!promotion.id || !promotion.name) {
              return null;
            }
            return (
              <PromotionItem
                promotion={promotion}
                key={`${promotion.id}`}
                listing={listing}
                activeAccordionId={activeAccordionId}
                onAccordionToggle={setActiveAccordionId}
              />
            );
          })}
        </>
      ) : (
        <EmptyState isBundlePromotion={false} />
      )}
    </Box>
  );
};

export default PromotionListing;
